<template>
    <Vue100vh ref="bodernePage" class="boderne base-page" id="bodernePage">
        <CircleWrap v-if="$route.name !== 'kraemmer'" @click.native="goBack" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="top" :class="{'hide-top': showBaseTop === true}">
            <div class="shadow"></div>
            <div class="stripes"></div>
        </div>
        <div class="content-wrap">
            <router-view></router-view>
        </div>
    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
    import gsap from 'gsap'
    import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
    export default {
	    name: "Boderne.vue",
	    components: {
	    	Vue100vh,
		    CircleWrap,
		    BackIconThin
	    },
	    watch:{
		    $route (to, from){
			    if(to.name === 'produkt') {
				    let that = this
				    setTimeout(function () {
					    that.$refs['bodernePage'].$el.scrollTop = 0
				    }, 5)
			    }
		    }
	    },
	    mounted(){
		    // Animation
            let that = this
		    that.animateIn()
	    },
        methods: {
	    	animateIn(){
			    let tl = gsap.timeline();
			    tl.to(".boderne .top", {delay: 0.5, x: 0, y: 0, opacity: 1, duration: 0.3});
			    tl.to(".boderne .content-wrap", {y: 0, opacity: 1, duration: 0.5, ease: 'power2.easeOut'});
            },
	    	goBack(){
	    		if(this.$route.path === "/boderne"){
				    this.$router.push('/')
                }else{
				    this.$router.go(-1)
                }
            }
        },
        computed: {
            showBaseTop(){
            	return (this.$route.name === 'kraemmer')
            }
        },
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_base-page";
    .boderne{
        .top{
            &.hide-top{opacity: 0 !important; pointer-events: none;}
            .stripes{
                background-color: $white;
                background-image: linear-gradient(90deg, transparent 50%, #C76875 50%);
            }
        }
    }
</style>
